export const TESTIMONIOS = [
  { txt: "En 3 meses pasé de no saber qué era un prompt a facturar 2.400 € al mes con servicios de IA para pymes.", who: "Laura M.", rol: "Alumna VIP · Sevilla", stars: 5 },
  { txt: "La única formación en español que va al grano: herramientas, sistema y cómo cobrar. Lo demás es ruido.", who: "Diego R.", rol: "Alumno · Valencia", stars: 5 },
  { txt: "El acceso VIP se paga solo. Una sola mentoría me ahorró meses de prueba y error con mi agencia.", who: "Camila T.", rol: "Alumna VIP · Madrid", stars: 5 },
];

export const CHAT_DEMO = [
  { av: "D", who: "Diego · CDMX", txt: "Acabo de cerrar mi segundo cliente con la plantilla del módulo 6 🔥", bot: false },
  { av: "L", who: "Laura · Sevilla", txt: "¡Enhorabuena! ¿Qué servicio le vendiste?", bot: false },
  { av: "D", who: "Diego · CDMX", txt: "Automatización de atención al cliente, 500 €/mes", bot: false },
  { av: "IA", who: "LIBI · Mentor IA", txt: "💡 Recordad: la llamada de mentoría de esta semana es el martes a las 19:00 (Madrid). Traed vuestros proyectos.", bot: true },
  { av: "C", who: "Camila · Buenos Aires", txt: "Ahí estaré, llevo mi primer agente para que lo reviséis 🙌", bot: false },
];

export const PILARES = [
  ["◈", "Dominio total", "Todas las herramientas relevantes, actualizadas cada mes. Cuando sale algo nuevo, ya está en el campus."],
  ["◇", "Sistema de ingresos", "Rutas probadas: servicios, productos digitales, agencia, SaaS. Eliges tu camino y lo ejecutas con plantillas reales."],
  ["◆", "Casos reales", "Cada módulo termina en un entregable vendible. Nada de teoría que no puedas cobrar."],
  ["✦", "Comunidad elite", "Miles de alumnos en España compartiendo clientes, oportunidades y resultados a diario."],
];

export const COMU_FEATS = [
  ["◉", "Chat en vivo 24/7", "Pregunta lo que sea a cualquier hora. Siempre hay alguien despierto — y LIBI, nuestro mentor IA, responde al instante."],
  ["◈", "Llamadas semanales en directo", "Cada semana: mentoría grupal, análisis de proyectos de alumnos y sesión de novedades IA. Todas quedan grabadas en el campus."],
  ["◆", "Retos mensuales con premio", "Cada mes, un reto práctico de monetización. Los mejores proyectos ganan mentoría privada y visibilidad ante toda la comunidad."],
  ["✦", "Networking en España", "Encuentra socios, clientes y colaboradores. Aquí se han creado agencias, SaaS y colaboraciones entre profesionales de toda la comunidad."],
  ["◰", "Portal de empleo y proyectos", "Publicamos ofertas de empleo y proyectos reales de IA para que apliques o colabores. Trabajo y clientes de verdad, dentro del campus."],
  ["❖", "Zona de recursos", "Todo el software de MAIA listo para copiar y vender: prompts, plantillas y herramientas para crear tus propios agentes de IA."],
];

export const SLOTS = ["10:00", "11:00", "12:30", "16:00", "17:30", "18:30"];

export const SOLICITUD_TIPOS = [
  ["primer_cliente", "🚀", "Buscar mi primer cliente", "Estoy preparado/a para conseguir y cerrar mi primer cliente de IA."],
  ["revisar_proyecto", "🔍", "Revisar mi proyecto", "Quiero que el equipo revise mi proyecto o negocio y me dé feedback."],
  ["mentoria", "🎯", "Quiero una mentoría", "Necesito una sesión de mentoría personalizada para avanzar."],
  ["subir_nivel", "📈", "Subir de nivel", "Ya facturo y quiero escalar: más clientes, precios o un equipo."],
];

export const SOLICITUD_LABELS = {
  primer_cliente: "Buscar mi primer cliente",
  revisar_proyecto: "Revisar mi proyecto",
  mentoria: "Quiero una mentoría",
  subir_nivel: "Subir de nivel",
};
